import { render, staticRenderFns } from "./DetailLayout.vue?vue&type=template&id=a6a00c18"
import script from "./DetailLayout.vue?vue&type=script&lang=js"
export * from "./DetailLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports